import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { fetchRelatedProducts } from 'redux/actions/booking';
import CrossSell from '../cross_sell';

export function RelatedProducts({
  title = 'Enhance your experience',
  text = '',
  type = 'relatedProducts',
  bookingId,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchRelatedProducts({ type, bookingId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const relatedProducts = useSelector(
    (state) => state.booking?.relatedProducts
  );

  const [finalProducts, setFinalProducts] = useState([]);

  useEffect(() => {
    if (!isEmpty(relatedProducts) && relatedProducts?.length) {
      setFinalProducts(
        relatedProducts.map((product) => ({
          id: product.id,
          title: product.title,
          imagePath: product.previewImage,
          link: product.url,
          price: {
            basePrice: product.productPrice,
            priceDefinition: product.productPriceDefinition,
          },
        }))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relatedProducts?.length]);

  if (!isEmpty(finalProducts)) {
    return (
      <div className="related-products">
        <CrossSell {...{ title, text, items: finalProducts }} />
      </div>
    );
  }
  return null;
}

RelatedProducts.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.string,
  bookingId: PropTypes.number,
};

export default RelatedProducts;
